import React from "react"
import PropTypes from "prop-types"
import BackgroundImage from 'gatsby-background-image'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Hero = ({ title, heroImage }) => (

  <BackgroundImage
    Tag="div"
    className="m-hero mb-6 md:mb-12"
    fluid={heroImage.childImageSharp.fluid}
  >
    <div className="m-hero__gradient"></div>
    <div className="container relative z-10">
      <div className="md:pl-10 lg:pl-20">
        <h2
          className="font-normal text-3xl md:text-4xl lg:text-5xl mb-3 leading-tight mb-6 block"
          dangerouslySetInnerHTML={{__html:title}}
        ></h2>

        <ul className="mb-8">
          <li className="text-xl mb-2"><FontAwesomeIcon className="text-primary text-lg mr-2" icon="check" /> All permits organised</li>
          <li className="text-xl mb-2"><FontAwesomeIcon className="text-primary text-lg mr-2" icon="check" /> Same or next day delivery</li>
          <li className="text-xl mb-2"><FontAwesomeIcon className="text-primary text-lg mr-2" icon="check" /> Best prices guaranteed</li>
        </ul>

        <div className="sm:flex sm:flex-wrap">
          <a href="#skip-sizes" className="btn btn--alt sm:mr-3 mb-3 sm:mb-0 block">View Skip Sizes</a>
          <a href="#quote" className="btn block">Get a Quote</a>
        </div>
      </div>
    </div>
  </BackgroundImage>
)

Hero.propTypes = {
  title: PropTypes.string,
  heroImage: PropTypes.object
}

Hero.defaultProps = {
  title: ``,
  heroImage: ``,
}

export default Hero